// kitchenStockApi.js
import apiClient from '../../../../../services/apiClient';

const withQuery = (base, params = {}) => {
  const query = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return query ? `${base}?${query}` : base;
};

export const kitchenStockApi = {
  getBalance: async (kindergartenId) => {
    const result = await apiClient.get(withQuery('kitchen/stock/balance', { kindergartenId }));
    return result.data || [];
  },

  getBatches: async (kindergartenId, { productId, status } = {}) => {
    const result = await apiClient.get(withQuery('kitchen/stock/batches', { kindergartenId, productId, status }));
    return result.data || [];
  },

  getExpiring: async (kindergartenId, daysAhead = 3) => {
    const result = await apiClient.get(withQuery('kitchen/stock/expiring', { kindergartenId, daysAhead }));
    return result.data || [];
  },

  getMovements: async (kindergartenId, { productId, type, dateFrom, dateTo } = {}) => {
    const result = await apiClient.get(withQuery('kitchen/stock/movements', { kindergartenId, productId, type, dateFrom, dateTo }));
    return result.data || [];
  },

  addReceipt: async (data) => {
    const result = await apiClient.put('kitchen/stock/receipt', data);
    return result.data;
  },

  writeOff: async (data) => {
    const result = await apiClient.put('kitchen/stock/writeoff', data);
    return result.data;
  },

  correctBatch: async (data) => {
    const result = await apiClient.put('kitchen/stock/batch/correct', data);
    return result.data;
  },

  // Quick-add a new trade item into the separate product-items dictionary (see
  // reference.split-products.patch.md), linked to an existing base product. Lets kitchen staff
  // register a new brand/package on the spot during receipt, without going through the admin
  // references screen — still one shared dictionary entry, not a per-kindergarten copy, so
  // cross-kindergarten aggregation by baseProductId keeps working for it like for anything the
  // admin adds. No category/unit here anymore — those belong to the base product only.
  createTradeProduct: async ({ name, baseProductId, packageSize, barcode }) => {
    const result = await apiClient.post('references/product-items', { name, baseProductId, packageSize, barcode });
    return result.data;
  }
};

export default kitchenStockApi;